import {Url} from "./Url.js";

window.formComponent = {
    forms: {},
    init: function () {
        $(document).on('submit', '.cform', formComponent.beforeSubmit);
        $(document).on('click', 'button.submit', formComponent.triggerSubmit);
    },
    triggerSubmit: function () {
        $(this).parents('form').trigger('submit', {target: this});
    },
    beforeSubmit: function (e, ex) {
        const $form = $(this);
        let $button;
        if (ex && ex.target) {
            $button = $(ex.target);
        } else {
            $button = $(e.target);
        }
        $button.block = function (value) {
            if($button && $button.is('button')) {
                $button.prop("disabled", value);
            }
        }

        const ajaxForm = $form.data('ajax') !== undefined;
        const context = {
            $form: $form,
            $button: $button,
            isAjaxForm: ajaxForm,
            data: null
        };

        formComponent.fn.eventCall('submit', context);

        return !ajaxForm;
    },
    submit: function (context) {
        try {
            formComponent.fn.eventCall('onBeforeValidate', context);
            if (formComponent.validate(context)) {
                if (context.isAjaxForm) {
                    const $form = context.$form;
                    const $button = context.$button;

                    $button.block(true);

                    const postParams = {
                        url: Url.to($form.attr('action')),
                    };
                    try {
                        context.data = new FormData($form[0]);
                        if(context.data.set === undefined) {
                            throw new Error('method set not found');
                        }
                        postParams['contentType'] = false;
                        postParams['processData'] = false;
                    } catch (e) {
                        console.error('FormData not supported', e);
                        context.data = new QueryString($form.serialize());
                    }

                    formComponent.fn.eventCall('injectData', context);

                    try {
                        context.data.set('loc_path', window.location.pathname);
                    } catch (e) {
                        console.error(e)
                    }

                    postParams.data = serialize(context.data);

                    $.post(postParams)
                        .then(function (response) {
                            context.response = response;
                            formComponent.fn.eventCall('onAjaxComplete', context);
                        })
                        .fail(function (r, s, e) {
                            context.r = r;
                            context.s = s;
                            context.e = e;
                            formComponent.fn.eventCall('onAjaxFail', context);
                        })
                        .always(function () {
                            formComponent.fn.eventCall('onAjaxAlways', context);
                            $button.block(false);
                        });
                }
            } else {
                formComponent.fn.eventCall('onFormFail', context);
            }
        } catch (e) {
            console.error(e);
        }
    },
    validate: function (context) {
        const $elements = $('input,textarea,select', context.$form);
        let passed = true;

        for (let i = 0; i < $elements.length; i++) {
            const $element = $($elements[i]);
            const value = $element.val();
            const required = $element.attr('aria-required') !== undefined || $element.attr('data-required') !== undefined;
            if (
                required && !formComponent.fn.required(value)
            ) {
                passed = false;
                context.$element = $element;
                formComponent.fn.eventCall('onElementFail', context);
                break;
            }
        }

        return passed;
    },
    fn: {
        eventCall: function (method, context) {
            const formId = context.$form.attr('id');
            const uniq = formComponent.forms[formId];
            if (uniq && uniq[method]) {
                uniq[method](context);
            } else {
                formComponent[method](context);
            }
        },
        isEmpty: function (value) {
            return value === null || value === undefined || ($.isArray(value) && value.length === 0) || value === '';
        },
        required: function (value, messages, options) {
            let valid = false;
            const isString = typeof value == 'string' || value instanceof String;
            if (!formComponent.fn.isEmpty(isString ? $.trim(value) : value)) {
                valid = true;
            }

            return valid;
        }
    },
    onBeforeValidate: function (context) {

    },
    onElementFail: function (context) {
        console.error('onElementFail', context);
    },
    onFormFail: function (context) {
        console.error('onFormFail', context);
    },
    onAjaxComplete: function (context) {
        console.info('onAjaxComplete', context);
    },
    onAjaxFail: function (context) {
        console.error('onAjaxFail', context);
    },
    onAjaxAlways: function (context) {
        console.info('onAjaxAlways', context);
    },
    injectData: function (context) {

    }
};

function QueryString(inq) {
    let query = inq;

    this.set = function (key, value) {
        const and = query ? '&' : '';
        query += `${and}${key}=${value}`;
    }

    this.get = function (key) {
        let result = undefined;
        const pairs = decodeURI(query).split('&');

        pairs.every(pair => {
            const data = pair.split('=');
            if (data[0] && data[1] && data[0] === key) {
                result = decodeURIComponent(data[1])
                return false;
            }
            return true;
        })

        return result;
    }

    this.getQuery = function () {
        return query;
    }

    this.entries = function () {
        const result = [];
        const pairs = decodeURI(query).split('&');

        pairs.forEach(pair => {
            const data = pair.split('=');
            result.push([data[0], decodeURIComponent(data[1])])
        })

        return result;
    }
}

function serialize(data) {
    if (data instanceof FormData) {
        return data;
    } else {
        return data.getQuery();
    }
}